import { Controller } from '@hotwired/stimulus'

// Handles form-level automation logic
// Note: Auto-selecting email templates is handled by automation-trigger controller
export default class extends Controller {
  connect() {
    // This controller wraps the automation form card body
  }
}
